<template>
	
	<div ref="titleBar" class="content-area__title-bar" :class="{ 'has-subtitle': subtitle != '' }">
		
		<!-- Icon / Title / Subtitle -->
		
		<div class="content-area__title-bar-inner">
			<slot name="image"><img v-if="icon" class="content-area__icon" :src="icon" :alt="title"></slot>
			<div class="content-area__title-subtitle-wrapper">
				<h2 class="content-area__title">{{ title }}</h2>
				<slot name="subtitle"><p v-if="subtitle" class="content-area__subtitle">{{ subtitle }}</p></slot>
			</div>
		</div>
		
		<!-- Tab Buttons -->
		
		<div class="content-area__tab-bar" v-if="tabs">
			<router-link v-for="(tab, i) in tabs" :to="{ name: tab.name }" class="content-area__title-bar-tab" :class="{ 'content-area__title-bar-tab--active': tab.path === selectedTab }" :key="i"><ion-icon :name="tab.meta.icon"></ion-icon>{{ tab.meta.title }}</router-link>
		</div>
		
		<!-- Action Buttons -->
		
		<div class="content-area__title-bar-actions">
			<slot name="actions"></slot>
		</div>
		
	</div>
	
</template>

<script>
	
	export default {
		
		props: {
			icon: { default: "" },
			title: { default: "" },
			subtitle: { default: "" },
			tabs: { default() { return []; } },
		},
		
		computed: {
			selectedTab() {
				return this.$route.path.split("/")[3];
			}
		},
		
		mounted() {
			this.height = this.$refs.titleBar.clientHeight;
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/ContentAreaTitle.vue